/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import CloseButton from '../buttons/CloseButton';

class Timepicker extends React.Component {

    state: State = {
        isAm: true,
        hours: null,
        minutes: null,
        date: null,
    };

    static propTypes = {
        msg: React.PropTypes.object,
        defaultValue: React.PropTypes.oneOfType([
            React.PropTypes.object,
            React.PropTypes.number
        ]).isRequired,
        onSubmit: React.PropTypes.func.isRequired,
        onClose: React.PropTypes.func.isRequired,
        label: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.changeIsAm = this.changeIsAm.bind(this);
        this.closeKeyboard = this.closeKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    isValid() {
        const {hours, minutes} = this.state;
        return hours !== null && minutes !== null;
    }

    onSubmit() {
        if (this.isValid()) {
            const {onSubmit} = this.props;
            const {hours, minutes, date} = this.state;
            const m = moment(date)
                .set('hour', parseInt(hours))
                .set('minute', parseInt(minutes))
                .set('second', 0)
                .set('millisecond', 0);

            onSubmit(m);
        }
    }

    closeKeyboard() {
        const {onClose} = this.props;
        onClose();
    }

    changeIsAm(am) {
        const {isAm, hours} = this.state;
        if (am !== isAm) {
            if (hours === null) {
                this.setState({'isAm': am});
            } else if (am) {
                this.setState({'isAm': am, hours: hours - 12});
            } else {
                this.setState({'isAm': am, hours: hours + 12});
            }
        }
    }

    componentWillMount() {
        const {defaultValue} = this.props;
        let value = defaultValue;
        if (defaultValue === null) {
            value = Date.now();
        }
        const m = moment(value).format('mm');
        const hours = parseInt(moment(value).format('HH'));

        const am = hours < 12;
        const zbytek = parseInt(m) % 5;
        const min = (parseInt(m) + 5 - zbytek);
        const minutes = zbytek > 0 ? `${min > 55 ? 55 : min}` : m;

        this.setState({minutes: minutes, hours: hours, isAm: am, date: value});
    }

    render() {
        const {isAm, hours, minutes} = this.state;
        const input = `${hours}:${minutes}`;
        const {label, msg} = this.props;

        return (
            <div className="keyboardPanel">
                <div className="keyboardPanel-panel">
                    <div className="keyboardPanel-row">
                        <span className="keyboardPanel-label">{label}</span>
                        <input className="keyboardPanel-input" value={input} readOnly/>
                    </div>
                </div>
                <div className="keyboardPanel-keyboard keyboard-place">
                    <div className="keyboardTime">
                        <div className="keyboardTime-phase">
                            <div className="verticalSwitch">
                                <div className={`verticalSwitch-option text-l color-greenLight ${isAm ? 'active' : ''}`}
                                     onClick={() => this.changeIsAm(true)}>
                                    <div className="verticalSwitch-inner">
                                        <span>{msg.timepicker.am}</span>
                                    </div>
                                </div>
                                <div className={`verticalSwitch-option text-l color-greenLight ${isAm ? '' : 'active'}`}
                                     onClick={() => this.changeIsAm(false)}>
                                    <div className="verticalSwitch-inner">
                                        <span>{msg.timepicker.pm}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {isAm &&
                        <div className="keyboardTime-hour">
                            {[...Array(12)].map((x, i) =>
                              <div className="keyboardTime-key" key={`timepicker-am-${i}`}>
                                <div
                                     className={`boxBtn text-l ${hours === i ? 'color-green text-white' : 'color-white'}`}
                                     onClick={() => this.setState({'hours': i})}>
                                    <div className="boxBtn-inner">
                                        <span>{i}</span>
                                    </div>
                                </div>
                              </div>
                            )}
                        </div>
                        }
                        {!isAm &&
                        <div className="keyboardTime-hour">
                            {[12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].map(x =>
                              <div key={`timepicker-pm-${x}`} className="keyboardTime-key">
                                <div
                                     className={`boxBtn text-l ${hours === x ? 'color-green text-white' : 'color-white'}`}
                                     onClick={() => this.setState({'hours': x})}>
                                    <div className="boxBtn-inner">
                                        <span>{x}</span>
                                    </div>
                                </div>
                              </div>
                            )}
                        </div>
                        }

                        <div className="keyboardTime-minute">
                            {['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'].map(x =>
                              <div className="keyboardTime-key" key={`timepicker-am-${x}`}>
                                <div className={`boxBtn text-l ${minutes === x ? 'color-green text-white' : 'color-white'}`}
                                     onClick={() => this.setState({'minutes': x})}>
                                    <div className="boxBtn-inner">
                                        <span>{x}</span>
                                    </div>
                                </div>
                              </div>
                            )}
                        </div>
                        <div className="keyboardTime-controls">
                          <div className="keyboardTime-controls-key">
                            <div className="boxBtn color-red" onClick={this.closeKeyboard}>
                                <CloseButton className="view-white"/>
                            </div>
                          </div>
                          <div className="keyboardTime-controls-key">
                            <div className={`boxBtn text-white color-greenLight ${this.isValid() ? '' : 'disabled'}`}
                                 onClick={this.onSubmit}>
                                <div className="boxBtn-inner">
                                  <svg className={`shape shape-enter`}>
                                    <use xlinkHref={`#shape-enter`}></use>
                                  </svg>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale]
}))(Timepicker);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/Timepicker.js